/* eslint-disable max-len */
import './config/PHMGStyles.css'
import './config/GlobalStyles.css';

import { useGetUserQuery } from '@config/state/globalSlices/apiSlice/requests';
import AuthLanding from 'compositions/auth';
import Login from 'compositions/auth/Form/Login';
import NewUserSetPassword from 'compositions/auth/Form/NewUserSetPassword';
import ResetPassword from 'compositions/auth/Form/ResetPassword';
import SetPassword from 'compositions/auth/Form/SetPassword';
import { HelmetProvider } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

// User Pages
import AccountPage from './compositions/account/Page';
// Auth Pages
// Experimental Pages
import BrandWorkshopListPage from './compositions/brandWorkshop/list';
import BrandWorkshopPage from './compositions/brandWorkshop/workshop';
import BrandWorkshopPreviewPage from './compositions/brandWorkshop/workshopPreview';
// Components
// Invoice Pages
import InvoicesPage from './compositions/invoices/Page';
import LocationAccountManagerPage from './compositions/location/account/locationAccountManager/Page';
import LocationBookAppointmentPage from './compositions/location/account/locationBookAppointment/Page';
import LocationRequestsPage from './compositions/location/account/locationRequests/Page';
import LocationAccountPage from './compositions/location/account/Page';
import LocationPage from './compositions/location/Page';
import LocationDetailsPage from './compositions/locationDetails/Page';
// Location Pages
import LocationsPage from './compositions/locations/Page';
// import ApprovedProductionsPage from './compositions/productions/approvedProductions/Page';
// import MusicAndVoiceoversPage from './compositions/productions/awaitingApproval/musicAndVoiceovers/Page';
// import AwaitingApprovalPage from './compositions/productions/awaitingApproval/Page';
// import ScriptsPage from './compositions/productions/awaitingApproval/scripts/Page';
// import ProductionsPage from './compositions/productions/Page';
import MyStudioPage from './compositions/myStudio/Page';
import { updateCustomer } from './config/state/globalSlices/userSlice';
import { PrivateRoute } from './shared/utils/PrivateRoute';

export const App = () => {
  const { data, isSuccess, isLoading, isError } = useGetUserQuery(undefined, {
    skip: !localStorage.getItem('accessToken'),
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (isError && !isLoading) {
    navigate('/ap/login');
  }

  if (isSuccess) {
    dispatch(updateCustomer(data));
  }

  return (
    <>
      <HelmetProvider>
        <Routes>
          <Route element={<PrivateRoute isLoading={isLoading} />}>
            {/* Top level account */}
            <Route path="/account" element={<AccountPage />} />

            {/* Locations */}
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/locations/:siteId" element={<LocationPage />} />
            <Route
              path="/locations/:siteId/invoices"
              element={<InvoicesPage />}
            />
            {/* Location Level account */}
            <Route
              path="/locations/:siteId/account"
              element={<LocationAccountPage />}
            />
            <Route
              path="/locations/:siteId/account/details"
              element={<LocationDetailsPage />}
            />
            <Route
              path="/locations/:siteId/account/manager"
              element={<LocationAccountManagerPage />}
            />
            <Route
              path="/locations/:siteId/book-appointment"
              element={<LocationBookAppointmentPage />}
            />
            <Route
              path="/locations/:siteId/requests"
              element={<LocationRequestsPage />}
            />

            {/* <Route path="/locations/:siteId/brand-workshop" element={<BrandWorkshopPage />} /> */}
            <Route
              path="/locations/:siteId/:siteAccNumber/brand-workshop"
              element={<BrandWorkshopListPage />}
            />
            <Route
              path="/locations/:siteId/:siteAccNumber/brand-workshop/:brandId"
              element={<BrandWorkshopPage />}
            />

            <Route
              path="/locations/:siteId/:siteAccNumber/my-studio"
              element={<MyStudioPage />}
            />

            {/* Productions */}
            {/* <Route path="/locations/:siteId/productions" element={<ProductionsPage />} />
            <Route path="/locations/:siteId/productions/awaiting-approval" element={<AwaitingApprovalPage />} />
            <Route path="/locations/:siteId/productions/awaiting-approval/music-and-voiceovers" element={<MusicAndVoiceoversPage />} />
            <Route path="/locations/:siteId/productions/awaiting-approval/scripts" element={<ScriptsPage />} />
            <Route path="/locations/:siteId/productions/approved-productions" element={<ApprovedProductionsPage />} /> */}
          </Route>

          {/* Public Routes */}
          <Route
            path="/preview/locations/:siteId/:siteAccNumber/brand-workshop/:brandId"
            element={<BrandWorkshopPreviewPage />}
          />

          {/* Auth Pages */}
          <Route path="/ap/login" element={<AuthLanding />} >
            <Route index element={<Login />} />
          </Route>

          <Route path="/ap/forgot-password" element={<AuthLanding />} >
            <Route index element={<ResetPassword />} />
          </Route>
          <Route path="/ap/set-password/:rc/:u" element={<AuthLanding />} >
            <Route index element={<SetPassword />} />
          </Route>
          <Route path="/ap/onboarding" element={<AuthLanding />}>
            <Route index element={<NewUserSetPassword/>} />
          </Route>
          {/* Wildcard for unrecognised routes */}
          <Route path="*" element={<Navigate to="/ap/login" />} />
        </Routes>
      </HelmetProvider>
    </>
  );
};
